import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import App from './App'
import { ThemeProvider } from '@mui/material/styles'

import theme from './theme'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnWindowFocus: false, staleTime: 300000 }
    }
})

let apps = []

window.attachNotifications = (id) => {

    if (apps.find(app => app[id])) {
        apps = apps.map(app => app[id] ? {
            [id]: ReactDOM.createRoot(
                document.getElementById(id)
            )
        } : app)
    } else {
        apps.push({
            [id]: ReactDOM.createRoot(
                document.getElementById(id)
            )
        })
    }

}

window.renderNotifications = (id) => {
    console.log(apps)
    apps.find(app => Object.keys(app)[0] === id)[id].render(
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </ThemeProvider>
        </QueryClientProvider>
    )
}

window.unmountNotifications = (id) => {
    apps.find(app => Object.keys(app)[0] === id)[id].unmount()
}

if (process.env.NODE_ENV == 'development') {
    window.attachNotifications('root')
    window.renderNotifications('root')
}